import React, { useState } from "react";
import "./styles.css";
import { Link, useStaticQuery, graphql } from "gatsby";
import { Menu, X } from "react-feather";

const NavigationBarPreview = ({ logo }) => {
  const [active, setActive] = useState(false);

  return (
    <header>
      <div className="container-Nav">
        <nav className={active ? "active" : ""}>
          <div onClick={() => setActive(!active)} className="menu-icons">
            <X className="ion-md-close" />
            <Menu className="ion-md-menu" />
          </div>
          <Link to="/de">
            <img className="logo" src={logo.fluid.src} alt="logo" />
          </Link>
          <ul className="nav-list">
            <li className="move-left">
              <div className="btn">
                <a
                  className="black-button"
                  href="mailto:&#101;&#107;&#112;&#64;&#101;&#107;&#112;&#46;&#99;&#122;"
                >
                  &#101;&#107;&#112;&#64;&#101;&#107;&#112;&#46;&#99;&#122;
                </a>
              </div>

              <div className="btn">
                <a className="black-button" href="tel:+420273139330">
                  +420 273 139 330
                </a>
              </div>
            </li>
            <li>
              <Link className="uppercase" to="/de/dienstleistungen/">
                Dienstleistungen
                <i className="icon ion-md-arrow-dropdown"></i>
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="/en/#about-us">
                Über uns
                <i className="icon ion-md-arrow-dropdown"></i>
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="/en/#team">
                Unser team
              </Link>
            </li>
            <li>
              <Link className="uppercase" to="/en/#contact">
                Contact
              </Link>
            </li>
            <li>
              <Link className="uppercase" id="languageMenu" to="/de">
                DE
              </Link>
              <ul className="sub-menu" style={{ width: "80px" }}>
                <li>
                  <Link to="/">CZ</Link>
                </li>
                <li>
                  <Link to="/en/">EN</Link>
                </li>
              </ul>
            </li>
            <li>
              <div className="move-top">
                <div className="btn-small">
                  <a
                    className="black-button"
                    href="mailto:&#101;&#107;&#112;&#64;&#101;&#107;&#112;&#46;&#99;&#122;"
                  >
                    &#101;&#107;&#112;&#64;&#101;&#107;&#112;&#46;&#99;&#122;
                  </a>
                </div>
              </div>
              <div className="move-top">
                <div className="btn-small">
                  <a className="black-button" href="tel:+420273139330">
                    +420 273 139 330
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

const NavigationBar = ({ location }) => {
  const { logo } = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "hp-logo.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            src
          }
        }
      }
    }
  `);

  return (
    <NavigationBarPreview logo={logo.childImageSharp} location={location} />
  );
};

export default NavigationBar;
